/*
 * FZK cart drawer layout + Extended Access toggle (v18, 2026-08-14)
 *
 * v18: Unwrap JS equipment restyle so the product image stays visible on
 *   the Liquid MAKE IT GO FURTHER card.
 *
 * v17: Kill leftover giftRestyle overlay so HIIT Pilates keeps its title
 *   and native ~~$124~~ FREE price instead of "FREE GIFT" / "$124$0".
 *
 * v16: Do not strike the subtotal. Screenshot summary is You saved + Subtotal.
 *
 * v15: Unhide EA as a normal line. Do not inject the EA toggle card, zone,
 *   gift restyle, or item reorder — those were the cart flicker. Equipment
 *   card, trust bar, chips, and assurance now live in Kozler Liquid.
 *
 * v14: HIDE EA LINE WITHOUT TOGGLE FLICKER. The EA cart line is always hidden
 *   in the drawer (toggle is the only UI). softRefreshAfterEa() never calls
 *   Kozler openAndRefresh — that remount was making other lines jump. CSS also
 *   hides .kozler-cart-item[data-variant-id=EA] so accidental remounts cannot
 *   flash the line. Remove still uses /cart/change.js + line key.
 *
 * v12: ROOT CAUSE of "toggle flickers / does not add" on preview.
 *   After a successful EA add we hide the EA cart line (.fzk-hidden-line).
 *   rowsByData() then built its match pool from VISIBLE rows only, so the
 *   hidden EA line was dropped, matching failed, apply fell through to the
 *   title path and bailed no-safe-root. Combined with openAndRefresh wiping
 *   the drawer, the switch flickered off even though /cart/add.js succeeded.
 *   Fix: (1) match ALL .kozler-cart-item rows including hidden ones;
 *   (2) ON path no longer calls openAndRefresh — soft re-apply from cart.js;
 *   (3) OFF path removes via /cart/change.js using the line key (works even
 *   when the EA row is hidden / not remounted).
 *
 * v11: TOGGLE FLICKER / FAILED-LOOKING ADD. After a successful /cart/add.js,
 *   refreshSurface() calls KozlerCartDrawer.openAndRefresh(), which wipes the
 *   drawer DOM. apply() often raced that remount, bailed with no-safe-root
 *   (items not in the DOM yet), and dropped the follow-up schedule because
 *   schedule() returns early while busy=true — so the card stayed off even
 *   though EA was in the cart. Fix: (1) queue a trailing apply when schedule
 *   fires during busy; (2) retry on transient bails; (3) hold an eaPending
 *   lock so remounts keep the optimistic ON state; (4) treat an add response
 *   that does not include the EA variant as failure (covers the preload's
 *   fake 200 {items:[]} blocked response).
 *
 * v10: EA TOGGLE NO LONGER NAVIGATES TO /cart. The ON path used a hidden
 *   native <form action="/cart/add"> and clicked its submit, assuming the
 *   theme's ajax handler would intercept via data-kozler-cart-open-on-submit.
 *   It doesn't: that hook lives on the theme's <ajax-cart-product-form>
 *   element, which a bare JS-built form is not inside, so the form posted
 *   natively and Shopify's POST /cart/add response redirected the customer to
 *   /cart - two surfaces away from checkout. The ON path is now a direct
 *   fetch('/cart/add.js') (same-origin JSON), with the EA allow flag raised
 *   exactly as before. After a successful add: drawer surfaces refresh in
 *   place (KozlerCartDrawer.openAndRefresh if present, else a cart:updated
 *   event) and the layout re-applies so the card flips to its ON state; the
 *   /cart page reloads in place (it is server-rendered, totals will not
 *   update otherwise) - the customer is already there, so nothing navigates
 *   anywhere new. On a failed add the switch reverts and re-enables. The OFF
 *   path is unchanged (still proxies the line's own remove control).
 *
 * v9: two design fixes, both approved against the v9 mockup.
 *   GIFT LINE - said "free" three times (FREE price + pink "-$124.00" label +
 *   the You're getting entry). Now: one mint "Free gift" pill for state, a
 *   struck original -> $0 for value, theme labels hidden in place.
 *   EQUIPMENT CARD - the theme's grey checkbox box is rebuilt IN PLACE as an
 *   offer card matching the EA card: eyebrow, title, price line, benefits,
 *   toggle. The theme's own content is wrapped in a hidden .fzk-eq-orig (never
 *   removed) and the toggle proxies the theme's real checkbox, so all add
 *   logic stays the theme's. No checkbox found -> block left untouched.
 *   Equipment now sits FIRST in the zone, before EA: bigger basket first,
 *   retention second. Price anchor comes from config eqPrice and stays blank
 *   until the checkbox mechanism is verified (swap vs add) - a wrong number
 *   in a cart is worse than none.
 *
 * v8: the theme summary's cart-level discount rows ("Discount" label +
 * "New Customer Offer -$30.00") duplicated the "You're getting" box directly
 * below them. hideDupDiscounts() hides those summary rows ONLY when the box
 * is actually rendered, so the discount is always proven somewhere exactly
 * once: struck subtotal for the maths, itemised box for the story.
 *
 * v7: ROW RESOLUTION IS NOW DATA-DRIVEN, NOT TEXT-DRIVEN. The Kozler drawer
 * renders every cart line as .kozler-cart-item carrying data-line-key and
 * data-variant-id (verified by reading the section source). rowsByData() maps
 * cart.js items to rows on those attributes - deterministic, no selector
 * guessing, no text matching. The v5/v6 title-matching path survives only as
 * a FALLBACK for surfaces without that markup (e.g. the /cart page).
 *
 * WHY: v5's hardened resolveRoot() (selector whitelist + reject-any-scope-
 * containing-header/footer) was written blind against the Kozler markup and
 * bailed on every cart - the two "working" QA screenshots predate the v5
 * deploy by minutes. The drawer either matches none of the whitelisted
 * selectors or its own internal header/footer elements trip the safety rule.
 * Scope for the checkout button / subtotal / equipment lookups now comes from
 * drawerScope(): ascend from the item container, never past body or main, so
 * the v4 footer-teleport class of bug stays impossible by construction.
 *
 * FZK_CART_LAYOUT.mode reports which path ran: 'data' or 'title'.
 *
 * v6: title matching broadened. The drawer renders the VARIANT title as the
 * line heading for equipment-bundle SKUs (e.g. "Program Access + Transform
 * Equipment"), while v5 only matched product_title or the full "Product -
 * Variant" string. One unmappable line trips the all-or-nothing guard and the
 * whole layout silently bails - which is correct behaviour, but it meant every
 * bundle cart (the highest-AOV carts) got the plain drawer with no Extended
 * Access card. titleNode now also matches variant_title and the split halves
 * of item.title, normalised for whitespace, case and trailing punctuation.
 * Matching remains exact-against-candidates inside validated safe scopes only.
 * Also added: FZK_CART_LAYOUT.lastBail so a silent bail is diagnosable from
 * the console instead of a re-derivation session.
 *
 * The active drawer (sections/kozler-cart-drawer.liquid, 327KB, app-generated)
 * is not editable in practice, so this reshapes the rendered DOM instead.
 *
 * WHAT THIS DOES
 *   1. ORDER: paid lines first, free/gift lines after.
 *   2. OFFERS ZONE: one container after the lines holding the equipment block
 *      (moved, not duplicated) and the Extended Access card.
 *   3. EA TOGGLE: one switch, two states. When EA is in the cart its LINE is
 *      hidden, because it was appearing twice: as a $0 "FREE" line and as an
 *      offer, which reads as a pricing bug on something that bills later.
 *   4. ZERO-DISCOUNT SUPPRESSION: see suppressZeroDiscounts().
 *   5. YOU'RE GETTING BLOCK: see youGetBlock().
 *   6. SUBTOTAL STRIKE: see subtotalStrike().
 *   7. STICKY FOOTER: see stickyFooter().
 *
 * SCOPE IS THE SAFETY PROPERTY OF THIS FILE. Read resolveRoot() before
 * changing anything here. Everything operates inside one validated container
 * and there is no document-wide fallback.
 *
 * TOGGLE PATHS
 *   ON  -> direct fetch('/cart/add.js') (v10; see changelog - the old hidden
 *          native form was never intercepted and navigated to /cart).
 *   OFF -> clicks the EA line's existing remove control, so removal still
 *          goes through the theme's own handler and the drawer never desyncs.
 *
 * THE EA ADD GUARD
 *   assets/extended-access-preload.js blocks any /cart/add whose payload is EA
 *   alone. __FITAZ_EA_CART_ADD_ALLOWED__ is that script's documented escape
 *   hatch; it is raised for the add and dropped after, so duplicate-line
 *   protection is not left disabled.
 *
 * Styling is a scoped stylesheet injected once. Tailwind is compiled ahead of
 * time in this theme, so utility classes invented at runtime would not exist in
 * the CSS bundle.
 *
 * Config comes from window.FZK_CART_UPSELL (sections/fzk-cart-offers.liquid).
 * Set it to null to disable. Every path is wrapped; on any error the drawer
 * renders exactly as it does without this file.
 */
(function () {
  'use strict';

  var VERSION = '2026-08-14.18';
  var ZONE_ID = 'fzk-upsell-zone';
  var STYLE_ID = 'fzk-cart-style';
  var EA_HIDE_STYLE_ID = 'fzk-ea-hide-style';
  var cache = { at: 0, data: null };
  var busy = false;
  var pendingApply = false;
  var timer = null;
  var retryTimer = null;
  var retryCount = 0;
  // 'on' | 'off' | null — survives Kozler remounts during an in-flight toggle.
  var eaPending = null;
  // After a successful add/remove, stale in-flight /cart.js responses can briefly
  // disagree with reality and flip the card the wrong way. Hold the intended
  // state for a short window so those snapshots cannot undo the toggle.
  var eaForceOnUntil = 0;
  var eaForceOffUntil = 0;

  function cfg() { return window.FZK_CART_UPSELL || null; }

  // Candidate cart containers, narrowest first. There is deliberately NO
  // document.body fallback. v4 had one, and it caused the worst bug in this
  // file's history: with no #CartDrawer in the Kozler markup, titleNode()
  // searched the whole document and matched the footer menu link "HIIT Pilates"
  // as if it were the cart line. lca() then resolved to near-<body>, reorder()
  // treated page sections as cart rows, and the site footer was moved to the
  // top of the PDP. If no safe container is found, this file does nothing.
  var ROOT_SELECTORS = [
    '.cart-items-wrapper',
    '#main-cart-items',
    '[data-ajax-cart-section-scroll]',
    '#CartDrawer',
    '[data-ajax-cart-section]',
    'cart-drawer',
    '.cart-drawer',
    '#cart-drawer',
    '[id*="CartDrawer"]',
    '[class*="cart-drawer"]'
  ];

  function isVisible(el) {
    return !!el && el.getClientRects().length > 0;
  }

  // A scope is unsafe if reshaping inside it could move page furniture.
  function unsafeScope(el) {
    if (!el || el === document.body || el === document.documentElement) return true;
    var tag = el.tagName;
    if (tag === 'HTML' || tag === 'BODY' || tag === 'MAIN' || tag === 'HEADER' || tag === 'FOOTER') return true;
    if (el.querySelector('footer, header')) return true;
    return false;
  }

  // Smallest visible container that holds a title node for EVERY cart line.
  // Smallest wins so we never reshape more of the page than the cart itself.
  function resolveRoot(cart) {
    var cands = [], i, j, found;
    for (i = 0; i < ROOT_SELECTORS.length; i++) {
      try { found = document.querySelectorAll(ROOT_SELECTORS[i]); } catch (e) { continue; }
      for (j = 0; j < found.length; j++) {
        if (cands.indexOf(found[j]) === -1) cands.push(found[j]);
      }
    }
    var best = null, bestSize = Number.MAX_VALUE;
    for (i = 0; i < cands.length; i++) {
      var el = cands[i];
      if (unsafeScope(el) || !isVisible(el)) continue;
      var ok = true;
      for (j = 0; j < cart.items.length; j++) {
        if (!titleNode(el, cart.items[j])) { ok = false; break; }
      }
      if (!ok) continue;
      var size = el.getElementsByTagName('*').length;
      if (size < bestSize) { best = el; bestSize = size; }
    }
    return best;
  }

  function money(cents) {
    var n = (cents || 0) / 100;
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      '#' + ZONE_ID + '{display:flex;flex-direction:column;gap:10px;margin:18px 0 4px;}',
      '#' + ZONE_ID + ' .fzk-zone-label{margin:0 0 2px;font-size:11px;letter-spacing:.08em;',
      'text-transform:uppercase;color:#A4A7AE;font-weight:600;}',
      '.fzk-card{border-radius:12px;padding:15px;position:relative;}',
      '.fzk-card--ea{background:#FFF2F7;}',
      '.fzk-card--ea:before{content:"";position:absolute;left:0;top:16px;bottom:16px;width:3px;',
      'background:#FDB6D3;border-radius:0 3px 3px 0;}',
      '.fzk-head{display:flex;justify-content:space-between;align-items:center;gap:14px;}',
      '.fzk-eyebrow{margin:0;font-size:11px;letter-spacing:.08em;text-transform:uppercase;',
      'color:#BF2C67;font-weight:600;}',
      '.fzk-title{margin:5px 0 0;font-size:14px;font-weight:600;color:#181D27;}',
      '.fzk-body{margin:9px 0 0;font-size:13px;line-height:1.5;color:#535862;}',
      '.fzk-price{font-weight:600;color:#181D27;white-space:nowrap;}',
      '.fzk-proof{margin:8px 0 0;font-size:12px;color:#911548;font-weight:500;}',
      '.fzk-disc{margin:10px 0 0;padding-top:10px;border-top:1px solid #FED6E7;font-size:11px;',
      'line-height:1.5;color:#717680;}',
      '.fzk-sw{width:46px;height:27px;border-radius:999px;background:#D5D7DA;border:none;padding:0;',
      'position:relative;cursor:pointer;flex:none;transition:background .18s ease;}',
      '.fzk-sw[aria-checked="true"]{background:#ED4281;}',
      '.fzk-sw[aria-busy="true"]{opacity:.55;pointer-events:none;}',
      '.fzk-kn{position:absolute;top:3px;left:3px;width:21px;height:21px;border-radius:50%;',
      'background:#fff;transition:transform .18s cubic-bezier(.4,0,.2,1);}',
      '.fzk-sw[aria-checked="true"] .fzk-kn{transform:translateX(19px);}',
      '.fzk-sw:focus-visible{outline:2px solid #BF2C67;outline-offset:2px;}',
      '.fzk-hidden-line{display:none !important;}',
      /* Summary shell is already outside the scroll (docked). Sticky here was
         redundant and on Firefox Android left a tall white gap above Checkout. */
      '#fzk-footer{position:static;z-index:5;background:#fff;padding:8px 0 0;',
      'box-shadow:none;}',
      '#fzk-youget{background:#FFF2F7;border:1px solid #FFE0EC;border-radius:12px;padding:10px 12px;',
      'margin:0 0 8px;}',
      '#fzk-youget h4{margin:0 0 8px;font-size:13px;font-weight:600;color:#BF2C67;}',
      '#fzk-youget ul{margin:0;padding:0;list-style:none;display:flex;flex-direction:column;gap:6px;}',
      '#fzk-youget li{display:flex;gap:8px;align-items:flex-start;font-size:13px;line-height:1.45;',
      'color:#414651;}',
      '#fzk-youget .fzk-ic{flex:none;width:16px;text-align:center;}',
      '.fzk-was{color:#A4A7AE;text-decoration:line-through;margin-right:6px;font-weight:400;}',
      '.fzk-gift-wrap{display:none!important;}',
      '.fzk-card--eq{background:#fff !important;border:1px solid #FFE0EC !important;}',
      '.fzk-card--eq:before{content:"";position:absolute;left:0;top:16px;bottom:16px;width:3px;',
      'background:#FDB6D3;border-radius:0 3px 3px 0;}',
      '.fzk-eq-price{margin:6px 0 0;font-size:13px;font-weight:600;color:#181D27;}',
      '.fzk-eq-benefits{margin:9px 0 0;padding:0;list-style:none;display:flex;flex-direction:column;gap:4px;}',
      '.fzk-eq-benefits li{font-size:12px;line-height:1.45;color:#535862;display:flex;gap:6px;align-items:flex-start;}',
      '.fzk-eq-benefits .fzk-tick{color:#ED4281;font-weight:700;flex:none;}',
      '.fzk-eq-img{width:56px;height:56px;border-radius:10px;object-fit:cover;flex:none;}',
      '.fzk-eq-orig{display:none !important;}',
      '@media (prefers-reduced-motion:reduce){.fzk-sw,.fzk-kn{transition:none;}}'
    ].join('');
    document.head.appendChild(s);
  }

  // Hide EA by variant id so Kozler remounts cannot flash the line before apply().
  function injectEaHideStyle(variantId) {
    if (!variantId) return;
    var id = String(variantId);
    var existing = document.getElementById(EA_HIDE_STYLE_ID);
    var css = '.kozler-cart-item[data-variant-id="' + id + '"]{display:none!important;}';
    if (existing) {
      if (existing.getAttribute('data-ea-vid') === id) return;
      existing.setAttribute('data-ea-vid', id);
      existing.textContent = css;
      return;
    }
    var s = document.createElement('style');
    s.id = EA_HIDE_STYLE_ID;
    s.setAttribute('data-ea-vid', id);
    s.textContent = css;
    document.head.appendChild(s);
  }

  function removeEaHideStyle() {
    var existing = document.getElementById(EA_HIDE_STYLE_ID);
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
  }

  function stripLegacyOverlay() {
    var i, el, nodes, zone, hide, c, vid;
    nodes = document.querySelectorAll('[data-fzk-ea-card], .fzk-gift-wrap');
    for (i = 0; i < nodes.length; i++) {
      el = nodes[i];
      if (el.parentNode) el.parentNode.removeChild(el);
    }
    el = document.getElementById('fzk-youget');
    if (el && el.parentNode) el.parentNode.removeChild(el);
    nodes = document.querySelectorAll('.kozler-cart-item__price--current.fzk-hidden-line');
    for (i = 0; i < nodes.length; i++) nodes[i].classList.remove('fzk-hidden-line');
    unwrapEquipmentCard();
    zone = document.getElementById('fzk-upsell-zone');
    if (zone && !zone.querySelector('.kozler-cart-upsell, .fzk-eq-card')) {
      if (zone.parentNode) zone.parentNode.removeChild(zone);
    }
    c = cfg();
    if (!c || !c.hideEaLine) {
      removeEaHideStyle();
      vid = c && c.eaVariantId ? String(c.eaVariantId) : '';
      nodes = document.querySelectorAll('.kozler-cart-item.fzk-hidden-line');
      for (i = 0; i < nodes.length; i++) {
        if (!vid || String(nodes[i].getAttribute('data-variant-id')) === vid) {
          nodes[i].classList.remove('fzk-hidden-line');
        }
      }
    }
  }

  function unwrapEquipmentCard() {
    var i, card, orig, child, next, cards, labels, zone, parent;
    cards = document.querySelectorAll('.fzk-card--eq, [data-fzk-eq-styled]');
    for (i = 0; i < cards.length; i++) {
      card = cards[i];
      orig = card.querySelector('.fzk-eq-orig');
      child = card.firstChild;
      while (child) {
        next = child.nextSibling;
        if (child !== orig && child.classList &&
            (child.classList.contains('fzk-head') ||
             child.classList.contains('fzk-eq-benefits') ||
             child.classList.contains('fzk-eq-img'))) {
          card.removeChild(child);
        }
        child = next;
      }
      if (orig) {
        while (orig.firstChild) card.insertBefore(orig.firstChild, orig);
        if (orig.parentNode) orig.parentNode.removeChild(orig);
      }
      card.classList.remove('fzk-card', 'fzk-card--eq');
      card.removeAttribute('data-fzk-eq-styled');
    }
    labels = document.querySelectorAll('.fzk-zone-label');
    for (i = 0; i < labels.length; i++) {
      if (labels[i].parentNode) labels[i].parentNode.removeChild(labels[i]);
    }
    zone = document.getElementById(ZONE_ID);
    if (zone && zone.parentNode) {
      parent = zone.parentNode;
      while (zone.firstChild) parent.insertBefore(zone.firstChild, zone);
      parent.removeChild(zone);
    }
  }

  function getCart(cb) {
    function done(c) {
      if (c) cache = { at: Date.now(), data: c };
      cb(c);
    }
    var now = Date.now();
    if (cache.data && now - cache.at < 800) { cb(cache.data); return; }
    if (window.FZK_CART && typeof window.FZK_CART.peek === 'function') {
      var peeked = window.FZK_CART.peek();
      if (peeked) { done(peeked); return; }
    }
    if (window.FZK_CART && typeof window.FZK_CART.get === 'function') {
      window.FZK_CART.get().then(done).catch(function () {});
      return;
    }
    try {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(done)
        .catch(function () {});
    } catch (e) {}
  }

  function lca(nodes) {
    if (!nodes.length) return null;
    var chains = nodes.map(function (n) {
      var c = [], x = n;
      while (x) { c.unshift(x); x = x.parentElement; }
      return c;
    });
    var best = null;
    for (var i = 0; i < chains[0].length; i++) {
      var candidate = chains[0][i], all = true;
      for (var j = 1; j < chains.length; j++) {
        if (chains[j].indexOf(candidate) === -1) { all = false; break; }
      }
      if (all) best = candidate; else break;
    }
    return best;
  }

  function norm(s) {
    return String(s == null ? '' : s).replace(/\s+/g, ' ').trim()
      .replace(/[.\u2026]+$/, '').toLowerCase();
  }

  // Text candidates a drawer might render as the line heading. The Kozler
  // drawer uses the product title for single-variant lines but the VARIANT
  // title for bundle SKUs, so both (and the halves of "Product - Variant")
  // must be acceptable. Exact match against this closed set only - never
  // substring - so page furniture can't be mistaken for a cart line.
  function titleCandidates(item) {
    var out = [], seen = {};
    function add(v) {
      var n = norm(v);
      if (n && !seen[n]) { seen[n] = 1; out.push(n); }
    }
    add(item.product_title);
    add(item.title);
    add(item.variant_title);
    var full = String(item.title || '');
    if (full.indexOf(' - ') !== -1) {
      var parts = full.split(' - ');
      add(parts[0]);
      add(parts.slice(1).join(' - '));
    }
    return out;
  }

  function titleNode(scope, item) {
    var wanted = titleCandidates(item);
    var els = scope.querySelectorAll('a, span, div, p, h3, h4, strong');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length) continue;
      var t = norm(el.textContent);
      if (!t) continue;
      for (var k = 0; k < wanted.length; k++) {
        if (t === wanted[k]) return el;
      }
    }
    return null;
  }

  function childOf(container, node) {
    var n = node;
    while (n && n.parentElement && n.parentElement !== container) n = n.parentElement;
    return (n && n.parentElement === container) ? n : null;
  }

  // PRIMARY row resolution. Each Kozler cart line is .kozler-cart-item with
  // data-line-key (unique per line) and data-variant-id. Match on the key
  // first, variant id second (with a used-set so duplicate variants cannot
  // collapse onto one row). Returns { entries, container } or null, in which
  // case the caller falls back to title matching.
  //
  // IMPORTANT: include hidden rows. We deliberately hide the EA line with
  // .fzk-hidden-line; if the pool is visibility-filtered, EA cannot be matched
  // on the next apply and the whole layout bails — which is exactly the
  // toggle-flickers-off bug after a successful add.
  //
  // Soft-add: after /cart/add.js we skip Kozler remount, so EA may be in
  // cart.js with no DOM row yet. Treat that as a virtual entry (row: null)
  // so apply can still render the ON card and bind the line key for remove.
  function rowsByData(cart) {
    var rows = document.querySelectorAll('.kozler-cart-item');
    if (!rows.length) return null;
    var pool = Array.prototype.slice.call(rows);
    var used = [], entries = [];
    var c = cfg();
    var eaId = c && c.eaVariantId ? String(c.eaVariantId) : '';
    for (var m = 0; m < cart.items.length; m++) {
      var it = cart.items[m], row = null, j;
      for (j = 0; j < pool.length; j++) {
        if (used.indexOf(pool[j]) !== -1) continue;
        if ((pool[j].getAttribute('data-line-key') || '') === String(it.key || '')) { row = pool[j]; break; }
      }
      if (!row) {
        for (j = 0; j < pool.length; j++) {
          if (used.indexOf(pool[j]) !== -1) continue;
          if (String(pool[j].getAttribute('data-variant-id') || '') === String(it.variant_id)) { row = pool[j]; break; }
        }
      }
      if (!row) {
        if (eaId && String(it.variant_id) === eaId) {
          entries.push({ item: it, row: null, virtual: true });
          continue;
        }
        return null;
      }
      used.push(row);
      entries.push({ item: it, row: row });
    }
    var real = [];
    for (var r = 0; r < entries.length; r++) {
      if (entries[r].row) real.push(entries[r]);
    }
    if (!real.length) return null;
    var container = real[0].row.parentElement;
    if (!container) return null;
    for (var k = 1; k < real.length; k++) {
      if (real[k].row.parentElement !== container) return null;
    }
    if (container === document.body || container === document.documentElement) return null;
    return { entries: entries, container: container };
  }

  // Widest drawer-looking ancestor of the item container. Search scope for the
  // checkout button, subtotal row and equipment block. Never ascends to body,
  // html or main, so page furniture is unreachable by construction - which is
  // the property v5 tried to buy with selector whitelists.
  function drawerScope(container) {
    var n = container, best = container;
    while (n.parentElement) {
      var p = n.parentElement, t = p.tagName;
      if (t === 'BODY' || t === 'HTML' || t === 'MAIN') break;
      n = p;
      var idc = (n.id || '') + ' ' + (n.getAttribute('class') || '') + ' ' + n.tagName;
      if (/kozler|cart[-_]?drawer|ASIDE|DIALOG/i.test(idc) || n.getAttribute('role') === 'dialog') best = n;
    }
    return best;
  }

  // The remove control the theme already renders on the line. Used by the
  // toggle's OFF path so removal goes through the theme's own handler.
  function removeControl(row) {
    var a = row.querySelector('a[href*="/cart/change"][href*="quantity=0"]');
    if (a) return a;
    a = row.querySelector('[data-ajax-cart-request-button]');
    if (a) return a;
    var cands = row.querySelectorAll('a, button');
    for (var i = 0; i < cands.length; i++) {
      var label = (cands[i].getAttribute('aria-label') || cands[i].textContent || '').toLowerCase();
      if (label.indexOf('remove') !== -1) return cands[i];
    }
    return null;
  }

  function reorder(container, entries) {
    var paid = [], free = [];
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      if (!e.row || e.virtual) continue;
      var isFree = (e.item.final_line_price === 0) ||
                   (e.item.properties && e.item.properties._fzk_gift) ||
                   (e.item.properties && e.item.properties._free_gift);
      (isFree ? free : paid).push(e);
    }
    var want = paid.concat(free);
    if (want.length < 2) return want;
    var same = true;
    for (var j = 1; j < want.length; j++) {
      if (want[j - 1].row.compareDocumentPosition(want[j].row) & Node.DOCUMENT_POSITION_PRECEDING) {
        same = false; break;
      }
    }
    if (same) return want;
    var ph = document.createComment('fzk-order');
    container.insertBefore(ph, want[0].row);
    for (var k = 0; k < want.length; k++) container.insertBefore(want[k].row, ph);
    if (ph.parentNode) ph.parentNode.removeChild(ph);
    return want;
  }

  function ensureZone(container, lastRow, label) {
    var zone = document.getElementById(ZONE_ID);
    if (!zone) {
      zone = document.createElement('div');
      zone.id = ZONE_ID;
      var h = document.createElement('p');
      h.className = 'fzk-zone-label';
      h.textContent = label || 'Make it go further';
      zone.appendChild(h);
    }
    if (lastRow && lastRow.parentNode === container && lastRow.nextSibling !== zone) {
      container.insertBefore(zone, lastRow.nextSibling);
    } else if (!zone.parentNode) {
      container.appendChild(zone);
    }
    return zone;
  }

  function moveEquipment(root, container, zone, heading) {
    if (!heading) return;
    var els = root.querySelectorAll('span, div, p, h2, h3, h4');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length) continue;
      if ((el.textContent || '').trim() !== heading) continue;
      var card = childOf(container, el);
      if (card && card !== zone && card.parentNode !== zone && root.contains(card)) {
        card.setAttribute('data-fzk-eq', '1');
        // Equipment sits FIRST in the zone, directly after the label - the
        // bigger-basket offer leads, the retention offer follows.
        var label = zone.firstElementChild;
        zone.insertBefore(card, label ? label.nextSibling : zone.firstChild);
      }
      return;
    }
  }

  function track(name, on) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, fzk_state: on ? 'on' : 'off' });
    } catch (e) {}
  }

  function eaSwitch(on) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fzk-sw';
    b.setAttribute('role', 'switch');
    b.setAttribute('aria-checked', on ? 'true' : 'false');
    b.setAttribute('aria-label', 'Add Extended Access');
    var k = document.createElement('span');
    k.className = 'fzk-kn';
    b.appendChild(k);
    return b;
  }

  // Soft refresh after EA toggle: never remount the Kozler drawer — that wipe
  // makes other lines jump. Do NOT dispatch cart:updated (Kozler may remount).
  // EA stays hidden via CSS + fzk-hidden-line; we only re-apply + bump badge.
  function softRefreshAfterEa() {
    cache.at = 0;
    cache.data = null;
    getCart(function (cart) {
      try {
        var n = cart && cart.item_count;
        if (typeof n === 'number') {
          var bubbles = document.querySelectorAll(
            '[data-cart-count], .cart-count, .cart-count-bubble, [aria-label*="Cart"]'
          );
          for (var i = 0; i < bubbles.length; i++) {
            var el = bubbles[i];
            if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', String(n));
            var label = el.getAttribute('aria-label');
            if (label && /cart/i.test(label)) {
              el.setAttribute('aria-label', label.replace(/\d+/, String(n)));
            }
          }
        }
      } catch (e) {}
      apply();
    });
    setTimeout(schedule, 400);
  }

  // Full remount refresh — used sparingly (e.g. /cart page, OFF fallback).
  function refreshSurface() {
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }
    try {
      if (window.KozlerCartDrawer && typeof window.KozlerCartDrawer.openAndRefresh === 'function') {
        window.KozlerCartDrawer.openAndRefresh();
      } else {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
    } catch (e) {}
    schedule();
    setTimeout(schedule, 350);
    setTimeout(schedule, 900);
  }

  function responseHasVariant(payload, variantId) {
    if (!payload || !variantId) return false;
    var want = String(variantId);
    var items = Array.isArray(payload.items) ? payload.items
              : (payload.variant_id || payload.id ? [payload] : []);
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (String(it.variant_id || it.id) === want) return true;
    }
    return false;
  }

  // The card renders in both states. `on` = EA is currently in the cart.
  // lineKey is the cart.js line key for EA (needed for /cart/change remove
  // when the Kozler row is hidden or was never remounted after a soft add).
  function eaCard(c, on, removeEl, lineKey) {
    var wrap = document.createElement('div');
    wrap.className = 'fzk-card fzk-card--ea';
    wrap.setAttribute('data-fzk-ea-card', '1');
    if (lineKey) wrap.setAttribute('data-fzk-ea-key', String(lineKey));

    var head = document.createElement('div');
    head.className = 'fzk-head';

    var left = document.createElement('div');
    left.style.flex = '1';
    var eb = document.createElement('p');
    eb.className = 'fzk-eyebrow';
    eb.textContent = c.eaEyebrow || 'When your program ends';
    var ti = document.createElement('p');
    ti.className = 'fzk-title';
    ti.textContent = c.eaTitle || 'Extend your access & save.';
    left.appendChild(eb);
    left.appendChild(ti);

    var sw = eaSwitch(on);
    head.appendChild(left);
    head.appendChild(sw);
    wrap.appendChild(head);

    var body = document.createElement('p');
    body.className = 'fzk-body';
    body.textContent = c.eaBody || '';
    if (body.textContent) wrap.appendChild(body);

    if (c.eaProof) {
      var pr = document.createElement('p');
      pr.className = 'fzk-proof';
      pr.textContent = c.eaProof;
      wrap.appendChild(pr);
    }

    // Disclosure is always in the DOM for screen readers, shown when on.
    var disc = document.createElement('p');
    disc.className = 'fzk-disc';
    disc.textContent = c.eaDisclosure || '';
    disc.style.display = on ? 'block' : 'none';
    if (disc.textContent) wrap.appendChild(disc);

    sw.addEventListener('click', function () {
      if (sw.getAttribute('aria-busy') === 'true' || eaPending) return;
      sw.setAttribute('aria-busy', 'true');
      cache.at = 0;
      if (on) {
        eaPending = 'off';
        eaForceOnUntil = 0;
        track('fzk_ea_toggle', false);
        wrap.setAttribute('data-state', 'off');
        sw.setAttribute('aria-checked', 'false');
        disc.style.display = 'none';
        var key = lineKey || wrap.getAttribute('data-fzk-ea-key');
        var finishOff = function (ok) {
          if (!ok) {
            eaPending = null;
            eaForceOffUntil = 0;
            wrap.setAttribute('data-state', 'on');
            sw.setAttribute('aria-checked', 'true');
            disc.style.display = 'block';
            sw.removeAttribute('aria-busy');
            return;
          }
          eaPending = null;
          eaForceOnUntil = 0;
          eaForceOffUntil = Date.now() + 2500;
          sw.removeAttribute('aria-busy');
          softRefreshAfterEa();
        };
        if (key) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: key, quantity: 0 })
          }).then(function (r) {
            if (!r.ok) throw new Error('ea-remove-' + r.status);
            return r.json();
          }).then(function () { finishOff(true); })
            .catch(function () {
              // Fall back to the theme remove control if change.js failed.
              if (removeEl) {
                try { removeEl.click(); } catch (e) {}
                setTimeout(function () { finishOff(true); }, 900);
              } else {
                finishOff(false);
              }
            });
        } else if (removeEl) {
          try { removeEl.click(); } catch (e) {}
          setTimeout(function () { finishOff(true); }, 900);
        } else {
          finishOff(false);
        }
      } else {
        eaPending = 'on';
        eaForceOffUntil = 0;
        track('fzk_ea_toggle', true);
        try {
          window.__FITAZ_EA_CART_ADD_ALLOWED__ = true;
          setTimeout(function () { window.__FITAZ_EA_CART_ADD_ALLOWED__ = false; }, 4000);
        } catch (e) {}
        // Optimistic flip; data-state too so apply() won't rebuild as off mid-flight.
        wrap.setAttribute('data-state', 'on');
        sw.setAttribute('aria-checked', 'true');
        disc.style.display = 'block';
        var line = { id: Number(c.eaVariantId), quantity: 1 };
        if (c.eaPlan) line.selling_plan = Number(c.eaPlan);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [line] })
        }).then(function (r) {
          if (!r.ok) throw new Error('ea-add-' + r.status);
          return r.json();
        }).then(function (payload) {
          // Preload's blockedResponse is status 200 with {items:[]} — treat as fail.
          if (!responseHasVariant(payload, c.eaVariantId)) {
            throw new Error('ea-add-empty');
          }
          var added = Array.isArray(payload.items) ? payload.items[0] : payload;
          if (added && added.key) wrap.setAttribute('data-fzk-ea-key', String(added.key));
          cache.at = 0;
          cache.data = null;
          eaPending = null;
          eaForceOffUntil = 0;
          eaForceOnUntil = Date.now() + 2500;
          sw.removeAttribute('aria-busy');
          softRefreshAfterEa();
        }).catch(function () {
          eaPending = null;
          eaForceOnUntil = 0;
          wrap.setAttribute('data-state', 'off');
          sw.setAttribute('aria-checked', 'false');
          disc.style.display = 'none';
          sw.removeAttribute('aria-busy');
        });
      }
    });

    return wrap;
  }

  // Discount labels that allocate $0 are noise. The gift's discount title is
  // applied to BOTH the gift line and its trigger line, but only allocates
  // money on the gift, so the trigger line rendered "Free HIIT Pilates
  // included  -$0.00", which reads as a bug. core-cart-item.liquid already
  // guards this with line_saved; the Kozler drawer does not. Driven off
  // line_level_discount_allocations, so it only ever hides a genuinely $0 row.
  function suppressZeroDiscounts(entries) {
    for (var i = 0; i < entries.length; i++) {
      var it = entries[i].item, row = entries[i].row;
      if (!row) continue;
      var allocs = it.line_level_discount_allocations || [];
      for (var a = 0; a < allocs.length; a++) {
        if (allocs[a].amount !== 0) continue;
        var title = (allocs[a].discount_application &&
                     allocs[a].discount_application.title) || '';
        if (!title) continue;
        var els = row.querySelectorAll('li, p, div, span');
        for (var k = 0; k < els.length; k++) {
          if (els[k].children.length) continue;
          if ((els[k].textContent || '').indexOf(title) === -1) continue;
          var host = els[k].closest('li') || els[k].parentElement || els[k];
          host.classList.add('fzk-hidden-line');
          break;
        }
      }
    }
  }

  // Itemised "You're getting" block. Every figure is read from cart.js rather
  // than written into copy: the previous version of this pattern hardcoded
  // "Get $30 off at checkout" while the discount actually applied was $40
  // (core-cart-drawer.liquid carried the same 3000 literal). A cart that
  // promises one number and charges another is worse than no block at all.
  //
  // Gifts are lines discounted to zero. Discounts are cart-level applications,
  // which is where the New/Returning Customer Offers land now they are ORDER
  // class. Line-level discounts on paid lines are already shown on the line.
  function youGetBlock(cart, c, foot) {
    var items = [];

    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.final_line_price === 0 && it.original_line_price > 0) {
        items.push({
          icon: c.giftIcon || '\uD83C\uDF81',
          text: 'Free ' + (it.product_title || it.title) + ' included - ' +
                money(it.original_line_price) + ' value'
        });
      }
    }

    var apps = cart.cart_level_discount_applications || [];
    for (var d = 0; d < apps.length; d++) {
      var amt = apps[d].total_allocated_amount || 0;
      if (amt <= 0) continue;
      items.push({
        icon: c.discountIcon || '\uD83D\uDCB3',
        text: (apps[d].title || 'Discount') + ' - ' + money(amt) + ' off'
      });
    }

    var box = document.getElementById('fzk-youget');
    if (!items.length) {
      if (box && box.parentNode) box.parentNode.removeChild(box);
      return;
    }
    if (!box) {
      box = document.createElement('div');
      box.id = 'fzk-youget';
      var h = document.createElement('h4');
      h.textContent = c.youGetTitle || "You're getting";
      box.appendChild(h);
      box.appendChild(document.createElement('ul'));
    }
    var ul = box.querySelector('ul');
    ul.textContent = '';
    for (var k = 0; k < items.length; k++) {
      var li = document.createElement('li');
      var ic = document.createElement('span');
      ic.className = 'fzk-ic';
      ic.setAttribute('aria-hidden', 'true');
      ic.textContent = items[k].icon;
      var tx = document.createElement('span');
      tx.textContent = items[k].text;
      li.appendChild(ic);
      li.appendChild(tx);
      ul.appendChild(li);
    }
    if (box.parentNode !== foot) foot.insertBefore(box, foot.firstChild);
  }

  // Show what the cart WAS next to what it is, inside the theme's own subtotal
  // row. Injecting a struck figure beside the existing amount is deliberately
  // less invasive than reordering the summary: the discount rows can stay where
  // the theme puts them, because the subtotal now explains itself.
  function subtotalStrike(root, cart) {
    var was = 0;
    for (var i = 0; i < cart.items.length; i++) was += cart.items[i].original_line_price || 0;
    if (was <= cart.total_price) return;

    var els = root.querySelectorAll('span, div, p, dt, th, h3, h4');
    for (var j = 0; j < els.length; j++) {
      if (els[j].children.length) continue;
      if ((els[j].textContent || '').trim().toLowerCase() !== 'subtotal') continue;

      var row = els[j].parentElement;
      if (!row) return;
      var priceEl = null, kids = row.querySelectorAll('span, div, p, dd, td');
      for (var k = 0; k < kids.length; k++) {
        if (kids[k].children.length) continue;
        if (kids[k] === els[j]) continue;
        if (/\d/.test(kids[k].textContent || '')) priceEl = kids[k];
      }
      if (!priceEl) return;

      var mark = priceEl.parentElement.querySelector('.fzk-was');
      if (!mark) {
        mark = document.createElement('s');
        mark.className = 'fzk-was';
        priceEl.parentElement.insertBefore(mark, priceEl);
      }
      mark.textContent = money(was);
      return;
    }
  }

  // Keep checkout in normal flow under the totals. The Kozler summary shell is
  // already a flex sibling outside .kozler-cart__scroll, so the button stays
  // visible without position:sticky. We still wrap the form so You're getting
  // can sit directly above Checkout without leaving a dead white band
  // (Firefox Focus / Xiaomi was painting sticky #fzk-footer as empty space).
  function stickyFooter(root, cart, c) {
    var btn = root.querySelector('button[name="checkout"], [name="checkout"]');
    if (!btn) return;
    var form = btn.closest('form') || btn;
    if (!form.parentNode) return;

    var foot = document.getElementById('fzk-footer');
    if (!foot) {
      foot = document.createElement('div');
      foot.id = 'fzk-footer';
      form.parentNode.insertBefore(foot, form);
    }
    foot.style.position = 'static';
    foot.style.boxShadow = 'none';

    if (c.showSavings) youGetBlock(cart, c, foot);

    if (form.parentNode !== foot) foot.appendChild(form);

    // Empty theme "Discount" rows left between Subtotal and Checkout.
    hideEmptyDiscountRows(root);
  }

  function hideEmptyDiscountRows(root) {
    if (!root) return;
    var rows = root.querySelectorAll('.kozler-cart__row--stacked');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var label = (row.querySelector('.kozler-cart__row-label') || row).textContent || '';
      if (!/discount/i.test(label)) continue;
      var amounts = row.querySelectorAll('.kozler-cart-item__discount-amount, li');
      var hasValue = false;
      for (var j = 0; j < amounts.length; j++) {
        if ((amounts[j].textContent || '').replace(/\s+/g, '').length > 0) {
          hasValue = true;
          break;
        }
      }
      if (!hasValue) row.classList.add('fzk-hidden-line');
    }
  }

  // Cart-level discount rows in the theme summary duplicate the "You're
  // getting" box. When the box is rendered, the summary's "Discount" label and
  // its application rows are hidden. Never touches line-level discount labels
  // and never runs when the box is absent, so proof of discount is never lost.
  function hideDupDiscounts(root, cart, c) {
    if (!c.showSavings) return;
    if (!document.getElementById('fzk-youget')) return;
    var apps = cart.cart_level_discount_applications || [];
    var titles = [], d;
    for (d = 0; d < apps.length; d++) {
      if ((apps[d].total_allocated_amount || 0) > 0 && apps[d].title) titles.push(apps[d].title);
    }
    if (!titles.length) return;
    var els = root.querySelectorAll('span, div, p, li, dt, dd');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length) continue;
      if (el.closest('#fzk-youget') || el.closest('#' + ZONE_ID)) continue;
      var t = (el.textContent || '').trim();
      if (!t) continue;
      if (t.toLowerCase() === 'discount') { el.classList.add('fzk-hidden-line'); continue; }
      for (var k = 0; k < titles.length; k++) {
        if (t.indexOf(titles[k]) === -1) continue;
        var host = el.parentElement || el;
        // Never hide a row that also carries the Subtotal or the item lines.
        if ((host.textContent || '').toLowerCase().indexOf('subtotal') !== -1 ||
            host.querySelector('.kozler-cart-item')) host = el;
        host.classList.add('fzk-hidden-line');
        break;
      }
    }
  }

  // Gift lines said "free" three times: the FREE price, the pink
  // "Free X included -$Y" label, and the You're getting entry. One signal per
  // surface: mint pill = state, struck original -> $0 = value (in the price
  // position where the eye expects it), the itemised box = story. Theme
  // elements are hidden in place, never removed.
  function giftRestyle(entries) {
    return;
  }

  // The theme's equipment block is a grey box with a bare checkbox - no price,
  // no product, no reason - next to a styled EA card, and it is the element
  // that turns a $129 cart into a $286 one. Rebuilt IN PLACE as an offer card:
  // our header + benefits are injected, the theme's own content is wrapped in
  // a hidden container (never removed), and the toggle proxies the theme's
  // real checkbox so its add logic is untouched. If no checkbox is found the
  // block is left exactly as the theme renders it.
  function equipmentCard(zone, c) {
    return;
  }

  function apply() {
    if (busy) { pendingApply = true; return; }
    var c = cfg();
    if (!c) return;

    getCart(function (cart) {
      try {
        busy = true;
        if (!cart || !cart.items || !cart.items.length) { bail('empty-cart', false); return; }
        injectStyle();
        if (c.hideEaLine) injectEaHideStyle(c.eaVariantId);
        else removeEaHideStyle();
        stripLegacyOverlay();

        var entries, container, scope;
        var byData = rowsByData(cart);
        if (byData) {
          entries = byData.entries;
          container = byData.container;
          scope = drawerScope(container);
          if (window.FZK_CART_LAYOUT) window.FZK_CART_LAYOUT.mode = 'data';
        } else {
          if (window.FZK_CART_LAYOUT) window.FZK_CART_LAYOUT.mode = 'title';
          scope = resolveRoot(cart);
          if (!scope) { bail('no-safe-root', true); return; }
          var nodes = [], unmapped = [];
          entries = [];
          for (var i = 0; i < cart.items.length; i++) {
            var n = titleNode(scope, cart.items[i]);
            if (n) { nodes.push(n); entries.push({ item: cart.items[i], node: n }); }
            else { unmapped.push(cart.items[i].title || cart.items[i].product_title); }
          }
          if (entries.length < cart.items.length) {
            bail('unmapped-lines: ' + unmapped.join(' | '), true);
            return;
          }

          container = lca(nodes);
          if (!container || unsafeScope(container) || !scope.contains(container)) { bail('no-safe-container', true); return; }
          for (var j = 0; j < entries.length; j++) {
            entries[j].row = childOf(container, entries[j].node);
            if (!entries[j].row) { bail('no-row-for: ' + (entries[j].item.title || ''), true); return; }
          }
        }
        bail(null, false);
        retryCount = 0;

        if (c.hideEaLine) {
          for (var k = 0; k < entries.length; k++) {
            var e = entries[k];
            if (String(e.item.variant_id) !== String(c.eaVariantId)) continue;
            if (e.row) e.row.classList.add('fzk-hidden-line');
          }
        }

        suppressZeroDiscounts(entries);
        stickyFooter(scope, cart, c);
        hideDupDiscounts(scope, cart, c);
      } catch (e) {
      } finally {
        busy = false;
        if (pendingApply) {
          pendingApply = false;
          schedule();
        }
      }
    });
  }

  function schedule() {
    clearTimeout(timer);
    if (busy) { pendingApply = true; return; }
    timer = setTimeout(apply, 200);
  }

  function bail(reason, retry) {
    try {
      if (window.FZK_CART_LAYOUT) window.FZK_CART_LAYOUT.lastBail = reason;
    } catch (e) {}
    if (retry && retryCount < 8) {
      retryCount += 1;
      clearTimeout(retryTimer);
      retryTimer = setTimeout(function () {
        cache.at = 0;
        schedule();
      }, 150 + retryCount * 100);
    }
  }

  function boot() {
    try {
      window.FZK_CART_LAYOUT = {
        version: VERSION,
        apply: apply,
        lastBail: null,
        mode: null,
        get pending() { return eaPending; }
      };
      var c0 = cfg();
      if (c0 && c0.hideEaLine && c0.eaVariantId) injectEaHideStyle(c0.eaVariantId);
      else removeEaHideStyle();
      apply();
      var drawer = document.querySelector('[data-cart-content], .kozler-cart, #CartDrawer');
      if (drawer) {
        new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
      }
      document.addEventListener('kozler:cart:refreshed', function (e) {
        if (e && e.detail && e.detail.cart && window.FZK_CART && window.FZK_CART.set) {
          window.FZK_CART.set(e.detail.cart);
        }
        cache.at = 0;
        schedule();
      });
      ['click', 'submit'].forEach(function (evt) {
        document.addEventListener(evt, function () { cache.at = 0; }, true);
      });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
